export type RuleKind =
  | 'required'
  | 'min'
  | 'max'
  | 'minLength'
  | 'maxLength'
  | 'pattern'
  | 'email'
  | 'dateMin'
  | 'dateMax';

export interface FieldRule {
  kind: RuleKind;
  value?: number | string;
  message?: string;
}

export interface ReadonlyBlock {
  type: 'readonly';
  label?: string;
  rows: [string, string][];
}

export interface ChoiceOption {
  value: string;
  label: string;
  hint?: string | null;
  tag?: string | null;
  disabled?: boolean;
  disabledReason?: string | null;
}

export interface ChoiceBlock {
  type: 'choice';
  field: string;
  label: string;
  options: ChoiceOption[];
  rules?: FieldRule[];
  default?: string | null;
}

export interface TextBlock {
  type: 'text';
  field: string;
  label: string;
  hint?: string | null;
  placeholder?: string | null;
  multiline?: boolean;
  rules?: FieldRule[];
  default?: string | null;
}

export interface NumberBlock {
  type: 'number';
  field: string;
  label: string;
  hint?: string | null;
  placeholder?: string | null;
  decimals?: 0 | 2;
  suffix?: string | null;
  rules?: FieldRule[];
  default?: number | null;
}

export interface DateBlock {
  type: 'date';
  field: string;
  label: string;
  hint?: string | null;
  rules?: FieldRule[];
  default?: string | null;
}

export interface ConfirmBlock {
  type: 'confirm';
  field: string;
  label: string;
  rules?: FieldRule[];
  default?: boolean | null;
}

export type FormBlock =
  | ReadonlyBlock
  | ChoiceBlock
  | TextBlock
  | NumberBlock
  | DateBlock
  | ConfirmBlock;

export type InputBlock = ChoiceBlock | TextBlock | NumberBlock | DateBlock | ConfirmBlock;

export function isInputBlock(block: FormBlock): block is InputBlock {
  return (
    block.type === 'choice' ||
    block.type === 'text' ||
    block.type === 'number' ||
    block.type === 'date' ||
    block.type === 'confirm'
  );
}

export interface FormAction {
  key: string;
  label: string;
  primary?: boolean;
  confirmText?: string | null;
  requiresPermission?: string | null;
  allowed: boolean;
}
